import React from 'react';

import pluralize from 'pluralize';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import { ValidationResult } from './types';

interface Props {
  open: boolean;
  onClose: () => void;
  onCommit: () => void;
  validationResult: ValidationResult | null;
}

export default function PartialCommitDialog({ open, onClose, onCommit, validationResult }: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Commit Partial Upload?</DialogTitle>
      <DialogContent>
        <Typography>
          {pluralize('row', validationResult?.errorCount ?? 0, true)} have database errors and will be skipped.
        </Typography>
        <Typography mt={1}>{validationResult?.validCount} valid rows will be committed. Continue?</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            onClose();
            onCommit();
          }}
        >
          Commit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
